import { Component, OnInit } from '@angular/core';
import { Gb } from 'src/app/core/services/growthbook.service';

@Component({
  selector: 'app-violations-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})
export class ViolationsDashboardComponent implements OnInit {
  public gb: Gb;
  constructor() {
    this.gb = new Gb();
  }

  ngOnInit() {
  }

}
